"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var React = _interopRequireWildcard(require("react"));
var _GaugeChart = _interopRequireDefault(require("./GaugeChart"));
var _data = _interopRequireDefault(require("./data.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let AppStyle = {
  fontFamily: "sans-serif",
  textAlign: "center"
};
function App(_ref) {
  let {
    json
  } = _ref;
  const [data, setData] = React.useState(null);
  React.useEffect(() => {
    setData(json || _data.default);
  }, [json]);
  if (!data) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  return /*#__PURE__*/React.createElement("div", {
    style: AppStyle
  }, /*#__PURE__*/React.createElement(_GaugeChart.default, {
    value: data.gaugeData.value,
    min: data.gaugeData.min,
    max: data.gaugeData.max,
    showHand: data.gaugeData.showHand,
    gradientColors: data.gaugeData.gradientColors
  }));
}
var _default = exports.default = App;